/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Import_Summary_No_Activities_TitleInputs */

const en_ui_import_summary_no_activities_title = /** @type {(inputs: Ui_Import_Summary_No_Activities_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to import yet`)
};

const de_ui_import_summary_no_activities_title = /** @type {(inputs: Ui_Import_Summary_No_Activities_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nichts zum Importieren`)
};

/**
* | output |
* | --- |
* | "Nothing to import yet" |
*
* @param {Ui_Import_Summary_No_Activities_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_no_activities_title = /** @type {((inputs?: Ui_Import_Summary_No_Activities_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_No_Activities_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_no_activities_title(inputs)
	return de_ui_import_summary_no_activities_title(inputs)
});